module.exports = __webpack_public_path__ + "static/media/javascript-es6.26c0437b.jpg";